import { memo } from "react";

import { BentoBoxCard } from "@react/sections/BentoBox/BentoBoxCard";
import { type BentoBoxCardProps } from "@root/tablescape/state/bentoBox";
import { type TTailwindString, tw } from "classnames";

export const styles = {
  base: tw(
    "grid",
    "grid-cols-1",
    "md:grid-cols-[1fr_2fr]" as TTailwindString,
    "grid-rows-[repeat(3,424px)]" as TTailwindString,
    "md:grid-rows-[repeat(2,328px)]" as TTailwindString,
    "mg:grid-rows-[repeat(2,446px)]" as TTailwindString,
    "lg:grid-rows-[repeat(2,542px)]" as TTailwindString,
    "gap-4",
    "lg:gap-6"
  ),
  card: (index: number) => tw({ "md:col-span-2": index === 2 }),
};

type Props = {
  btnLabel?: string;
  cards: BentoBoxCardProps[];
  handleModalOpen: (index: number) => void;
};

const BentoBoxCardsLayoutABase = ({
  btnLabel,
  cards,
  handleModalOpen,
}: Props) => {
  return (
    <div className={styles.base}>
      {cards.map((card, index) => {
        return (
          <BentoBoxCard
            {...card}
            {...(card.modalContent?.showModal && {
              handleCtaClick: () => handleModalOpen(index),
            })}
            btnLabel={btnLabel}
            className={styles.card(index)}
            key={`bento-box_layout-a_card-${index}`}
            position={index + 1}
          />
        );
      })}
    </div>
  );
};

export const BentoBoxCardsLayoutA = memo(BentoBoxCardsLayoutABase);
